import Request from "./index";

class api {
  //【前台】获取专递课堂列表（分页）
  static getDeliveryClassList(data) {
    return Request.get('/delivery_class/page', {
      params: data
    })
  }
}

export default api;
